import styled from 'styled-components';

export const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  background: #f9f9fb 0% 0% no-repeat padding-box;
  overflow: auto;
  min-height: 100%;
  position: relative;

  @media (max-width: 759px) {
    padding-bottom: 3rem;
  }
`;

export const Footer = styled.footer`
  font-size: 12px;
  letter-spacing: 0px;
  color: #78849e;
  opacity: 1;
  text-align: center;
  background: #f9f9fb 0% 0% no-repeat padding-box;
  margin: 3rem 0 0 1rem;
  position: absolute;
  bottom: 10px;
  left: 50%;
  transform: translateX(-50%);

  @media (max-width: 759px) {
    white-space: nowrap;
    margin: 0px;
  }
`;
